import execWm from "@/../../hypetrain/static/img/exec-wm.png";
import { Link } from "react-router";

import { getStartPageURL } from "@/components/helpers/url-utils";
import { Box, Flex } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import { MobileNav } from "@/components/nav/PublicNav/MobileNav";
import { NavLinks } from "@/components/nav/PublicNav/NavLinks";
import { Container } from "@/components/pieces/bootstrap";
import { Button } from "@/components/ui/button";
import {
  NAV_Z_INDEX,
  STANDARD_NAV_HEIGHT,
  PUBLIC_CONTENT_MAX_WIDTH,
} from "@/css/constants";

interface ExecNavProps {
  fullWidth?: boolean;
}

export function ExecNav({ fullWidth = false }: ExecNavProps) {
  return (
    <div
      className="fixed top-0 left-0 w-full bg-white py-2 shadow-xs"
      style={{ zIndex: NAV_Z_INDEX }}
    >
      <Container maxWidth={fullWidth ? "100%" : PUBLIC_CONTENT_MAX_WIDTH}>
        <Flex
          minHeight={STANDARD_NAV_HEIGHT - 16}
          alignItems="center"
          justifyContent="space-between"
        >
          <Flex alignItems="center">
            <Box minWidth={120}>
              <Link className="block py-2" to="/">
                <img
                  src={execWm}
                  style={{ height: 24 }}
                  width="105"
                  height="24"
                  alt="Exec"
                />
              </Link>
            </Box>
            <Media greaterThan="md">
              <NavLinks pill={true} />
            </Media>
          </Flex>
          <Flex />
          <Media greaterThan="md">
            <div className="flex items-center gap-4">
              <Button asChild variant="minimal" size="sm">
                <Link to="/login">Login</Link>
              </Button>
              <Button asChild variant="outline" size="sm">
                <Link to={getStartPageURL("?nextPath=/roleplays")}>
                  Get Started
                </Link>
              </Button>
            </div>
          </Media>
          <Media lessThan="lg">
            <Flex>
              <Button variant="outline" asChild size="sm">
                <Link to={getStartPageURL()}>Get Started</Link>
              </Button>
              <Flex ml={3} alignItems="center">
                <MobileNav hideLogin={false} />
              </Flex>
            </Flex>
          </Media>
        </Flex>
      </Container>
    </div>
  );
}
